<template>

    <div class="uuid" @click="copyText" @mouseenter="hovering = true" @mouseleave="hovering = false" :title="uuid">
        <div class="uuid-body">
            <span class="uuid-label text-muted" :class="{ hidden: hovering }">
                <span><span class="label">UUID</span></span>
            </span>
            <span class="uuid-label text-muted" :class="{ hidden: !hovering }">
                <span><span class="label">ID</span> {{ identifier | truncate(10) }}</span>
                <span class="divider"> | </span>
                <span><span class="label">UUID</span> {{ uuid | truncate(10) }}</span>
            </span>
            <span class="ml-5">
                <i v-if="!copied" class="fas fa-clipboard"></i>
                <i v-else class="fas fa-clipboard-check text-success"></i>
            </span>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .uuid {
        height: 26px;
        position: relative;
    }

    .uuid-body {
        @include font-medium(12px);
        align-items: center;
        border-radius: 3px;
        box-sizing: border-box;
        color: $color-text;
        cursor: pointer;
        display: flex;
        height: inherit;
        justify-content: center;
        padding: 5px 7px;
        position: absolute;
        right: 0;
        text-align: right;
        top: 0;
        transition: .3s background-color;
        user-select: none;
        white-space: nowrap;
        &:hover {
            background: $color-bg;
        }
        .label {
            @include font-semibold(12px);
        }
        .divider {
            opacity: 0.5;
        }
    }

</style>

<script>

export default {

    props: {
        identifier: {
            type: Number,
            required: true,
        },
        uuid: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            copied: false,
            hovering: false,
        }
    },

    methods: {

        copyText() {
            navigator.clipboard.writeText(this.uuid)
                .then(() => {
                    this.$store.commit('setAlertSuccess', this.$t('messages.copied'));
                    this.copied = true;
                })
                .catch(() => {
                    this.$store.commit('setAlertError', 'Unable to copy text.');
                });
        },

    },

}

</script>
